import { useState } from "react";
import { BaseButton, BaseInput } from "../../components/base";
import { useNotification } from "../../context/NotificationProvider";
import { login } from "../../api/auth/authAPI";
import { Box, Typography, InputAdornment, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import logo from "../../assets/images/hashinLogoLight.png";
import useAuth from '../../hooks/useAuth';
import URIs from "../../utils/uri";
import { hashPassword } from "../../utils/helpers";
import { jwtDecode } from "jwt-decode";

const Login = () => {
  const [phoneValue, setPhoneValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const {showNotification} = useNotification();
  const { setAuth } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsloading(true);
    try {
      const res = await login(phoneValue, hashPassword(passwordValue));
      
      setAuth(prev => {
        let decodedToken = jwtDecode(res.accessToken)
        const roles = decodedToken.roles
        return { ...prev, roles: roles, firstName: res.firstName, authStatus : res.authStatus, accessToken: res.accessToken }
      });

      if(res.authStatus === 1){
          navigate(URIs.SET_PASSWORD, { state: { phone: phoneValue} });
      }else if(res.authStatus === 2){
          navigate(URIs.KYC);
      }else if(res.authStatus === 3){
          navigate(URIs.HOME);
      }else{
          navigate(URIs.HOME);
      }
    } catch (error) {
        showNotification(error, 'error')
    } finally {
      setIsloading(false);
    }
  };

  const openForgotPassword = () => {
	  navigate(URIs.REGISTER)
  }

  const openRegister = () =>  {
    navigate(URIs.REGISTER)
  }

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flexStart"
      alignItems="center"
      padding={2}
      gap={4}
      sx={{ height: "100vh", paddingTop: '80px' }}
    >
      <img
        src={logo}
        alt="Logo"
        style={{ width: "120px" }}
      />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        style={{ width: "90%", maxWidth: 400 }}
        gap={2}
      >
        <Typography variant="title">خوش آمدید</Typography>
        <Typography variant="subtitle" sx={{ textAlign: 'center' }}>
          لطفا با شماره تماس و رمز خود وارد شوید
        </Typography>
      </Box>
      <form onSubmit={handleSubmit} style={{ width: "90%", maxWidth: 400 }}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="stretch"
          gap={2}
        >
          <BaseInput
            label="شماره موبایل"
            value={phoneValue}
            onChange={(e) => setPhoneValue(e.target.value)}
            name="username"
            type="number"
            autoComplete="username"
          />
          <BaseInput
            label="رمز"
            value={passwordValue}
            onChange={(e) => setPasswordValue(e.target.value)}
            name="password"
            type={showPassword ? "text" : "password"}
            autoComplete="current-password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleTogglePasswordVisibility}
                    edge="end"
                    aria-label="toggle password visibility"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility /> }
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <BaseButton
            type="submit"
            isLoading={isLoading}
          >
            ورود
          </BaseButton>
        </Box>
      </form>
	  <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={2}
      >
        <Typography variant="subtitle" color='textDefault' onClick={openForgotPassword} sx={{ cursor: 'pointer' }}>
          رمز عبور را فراموش کرده‌ام
        </Typography>
      </Box>
	  <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        gap={2}
      >
        <Typography variant="subtitle">حساب کاربری ندارید؟</Typography>
		    <Typography variant="subtitle" color='textDark' onClick={openRegister} sx={{ cursor: 'pointer' }}>
          ثبت نام
        </Typography>
      </Box>
    </Box>
  );
};

export default Login;
